var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.2,9.6H1.3c-0.6,0-1-0.4-1-1V3.4c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v5.2C8.3,9.2,7.9,9.6,7.2,9.6C7.3,9.7,7.2,9.7,7.2,9.6 z M1.3,3.3v5.3h6l0,0V3.4L1.3,3.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.3,9.5c-0.1,0-0.2,0-0.3-0.1L8.5,7.6C8.4,7.5,8.3,7.4,8.3,7.2V5c0-0.2,0.1-0.3,0.2-0.4L11,2.9c0.2-0.1,0.4-0.1,0.5,0 c0.2,0.1,0.3,0.3,0.3,0.4V9c0,0.2-0.1,0.4-0.3,0.4C11.4,9.5,11.4,9.5,11.3,9.5z M9.3,6.9L10.8,8V4.2l-1.5,1L9.3,6.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    x: 0.7,
    y: 3,
    width: 6.8,
    height: 5.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.3,8.2h-1.2C9.5,8.2,9,7.7,9,7.1v-2C9,4.5,9.5,4,10.1,4h1.2V8.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.0f8d83810db5db0c2e7d4f6d2845dbee.svg";
export { ForwardRef as ReactComponent };